import { Card, CardContent } from "@mui/material";

const CustomCard = ({
  children,
  backgroundColorStyle,
  stylePadding,
  widthCard,
  heightCard,
  overflowCard,
}) => {
  return (
    <Card
      style={{
        background: backgroundColorStyle,
        width: widthCard,
        margin: "auto",
        paddingLeft: stylePadding,
        height: heightCard ? heightCard : "76vh",
        borderRadius: "20px",
        boxShadow: "none",
        // overflowX: "hidden",
        overflowY: overflowCard,
      }}
    >
      <CardContent>{children}</CardContent>
    </Card>
  );
};

export default CustomCard;
